module.exports = __webpack_public_path__ + "8a31a96f57ce71414642732a0791c716.svg";